/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react'
import Topbar from '../../components/common/topbar/Topbar'
import { AttributeDTO, AttributeNewsan, FilterTable, FilterTableType, StoreCatalogacion, TableAction, TableDetailCell, TableHeaderCell, TreeNode } from '../../model/models-module'
import { addParam } from '../../utils/CommonUtils'
import {useData} from '../../components/hooks/useData'
import DataTable from '../../components/common/datatable/Datatable'
import { Autocomplete, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, MenuItem, Modal, Select, styled, TextField, Typography} from '@mui/material'
import classes from './Attributes.module.css'
import { GridDTO } from '../../model/dto-module'
import { useNavigate, useParams } from 'react-router-dom'
import EditIcon from '@mui/icons-material/Edit';
import NewsanIcons from '../../components/common/Icons'
import CloseIcon from '@mui/icons-material/Close'
import axios from 'axios'
import AxiosInterceptor from '../../services/http/AxiosInterceptor'
import PopupSuccessError from '../../components/common/popup-success-error/PopupSuccessError'
import ConfirmDialog from '../../components/common/confirm-dialog/ConfirmDialog'
import CustomAutocomplete from '../../components/common/custom-autocomplete/CustomAutocomplete'
import { toast } from 'react-toastify'
// import AxiosInterceptor from '../../services/http/AxiosInterceptor'

class AttributesGridDTO<T> extends GridDTO<T> {
  categoryData?: any;
}

const Attributes = () => {
  const client = AxiosInterceptor.addInterceptor(process.env.REACT_APP_API_BASE_URL)
  const [errorResponse, setErrorResponse] = useState<string[] | null>(null);
  const [dataResponse, setDataResponse] = useState<string | null>(null);
  const {id: idStore, relationsCategoryId: idRelationsCategory} = useParams();
  const [dataHeader, setDataHeader] = useState<TableHeaderCell[]>([]);
  const [dataTo, setDataTo] = useState<number>(50);
  const [countItems, setCountItems] = useState<number>(0);
  const [dataOffset, setDataOffset] = useState<number>(0);
  const [dataShow, setDataShow] = useState<TableDetailCell[]>([]);
  const [baseEndpoint, setBaseEndpoint] = useState<string>(`/attributes/byRelationCategory/${idRelationsCategory}`);  
  const [loadingStore, errorStore, dataStore] = useData<StoreCatalogacion>(`/stores/${idStore}`, 'GET', undefined);
  const [endpoint, setEndPoint] = useState<string>('');
  const [params] = useState<Map<string,string>>(new Map());
  const [loading, error, dataGrid] = useData<AttributesGridDTO<AttributeDTO>>(endpoint, 'GET', undefined);
  const [showForm, setShowForm] = useState<boolean>(false);
  const [loadingResponse, setLoadingResponse] = useState(false);
  const [newEditItem, setNewEditItem] = useState<AttributeDTO>();
  const [selectedAttributeGEND, setSelectedAttributeGEND] = useState<AttributeNewsan>();
  const [loadingOptionsGend, errorOptionsGend, dataOptionsGend] = useData<AttributeNewsan[]>(`/attributes/gendByRelationsCategory/${idRelationsCategory}/autocomplete`, 'GET', undefined);
  const [showPopup, setShowPopup] = useState<boolean>(false);
  const [idsSuggested, setIdsSuggesteds] = useState<number[]>([]);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [selectedRelationId, setSelectedRelationId] = useState<number | null>(null);
  const useIa = true;
  const [openIaModal, setOpenIaModal] = useState(false);
  const handleCloseIaModal = () => setOpenIaModal(false);
  const [codeStoreFilter, setCodeStoreFilter] = useState<string>('');
  const [withNoRelationFilter, setWithNoRelationFilter]= useState<string>();
  const [showAddAttributes, setShowAddAttributes] = useState(false);
  const [endpointAttributes, setEndpointAttributes] = useState<string | null>(!dataStore?.integrator.api ? '': null);
  const [loadingAttributesToAdd, errorAttributesToAdd, dataAttributesToAdd] = useData<AttributeDTO[]>(endpointAttributes, 'GET', undefined);
  const [selectedAttributes, setSelectedAttributes] = useState<AttributeDTO[]>([]);
  const [headerActions] = useState<TableAction[]>(!dataStore?.integrator.api ? [
    new TableAction({
      label: 'Agregar atributos',
      action: () => setShowAddAttributes(true),
      icon: NewsanIcons.ADD_OUTLINED
    })
  ]:
  []);

  function onCloseAddAttrModal(){
    setShowAddAttributes(false);
    setSelectedAttributes([])
  }

  const navigate = useNavigate();

  useEffect(()=> {
    if (baseEndpoint == '') setBaseEndpoint(`/attributes/byRelationCategory/${idRelationsCategory}`)
  }, [baseEndpoint])

  useEffect(()=> {
    if (endpointAttributes == '' && dataGrid && dataGrid?.categoryData) setEndpointAttributes(!dataStore?.integrator.api ? `/attributes-without-category/${idStore}?categoryStoreId=${dataGrid?.categoryData.id}`: null)
  }, [endpointAttributes, dataGrid])

  useEffect(()=> {
    addParam(dataTo, 'size', params, baseEndpoint, setEndPoint);
  }, [dataTo, baseEndpoint]);

  useEffect(()=> {
    addParam(dataOffset, 'page', params, baseEndpoint, setEndPoint);
  }, [dataOffset, baseEndpoint]);

  useEffect(()=> {
    setDataOffset(0)
    addParam(codeStoreFilter, 'storeDescription', params, baseEndpoint, setEndPoint);
  }, [codeStoreFilter, baseEndpoint]);

  useEffect(()=> {
    setDataOffset(0)
    addParam(withNoRelationFilter, 'withNoRelation', params, baseEndpoint, setEndPoint);
  }, [withNoRelationFilter, baseEndpoint]);

  useEffect(()=> {
    if(dataHeader.length === 0 ) {
      setDataHeader([
        new TableHeaderCell({label: 'Cod - Atributo Tienda', key: 'codeStore', sorteable: false,
          filter: new FilterTable({type: FilterTableType.TEXT, placeholder: 'Busca aqui...', onChange(newVal) {
            setCodeStoreFilter(newVal)
          }, }),
        }),
        new TableHeaderCell({label: 'Tipo Atributo Tienda', key: 'dataType', sorteable: false}),
        new TableHeaderCell({label: 'Cod - Atributo GenD', key: 'codeNewsan', sorteable: false,
          filter: new FilterTable({type: FilterTableType.COMBO, useCodeField: true, data:
            [{
              id: 1, code: '1', description: 'Sin configurar'
            },
            {
              id: 0, code: '0', description: 'Con categoria'
            }]
            , onChange(newVal) {
              setWithNoRelationFilter(newVal)
            },
          })
        }),
      ])  
    }
  })

  const fetchData = async ( body?: {attributeNewsanId: number}, relationId?: number) => {
    try{
      setLoadingResponse(true)
      setOpenIaModal(useIa)
      let iaResponse = undefined
      if (newEditItem?.relationAttributes[0]?.id || relationId){
        const response = await client.patch(`/attributes/${relationId ?? newEditItem?.relationAttributes[0].id}`, {...body, asistenteIaAtributos: useIa})
        iaResponse = response.data.iaResponse
        setDataResponse('Modificado con éxito!')
        setErrorResponse(null)
        setNewEditItem(undefined)
      }else{
        const response = await client.post('/attributes/createRelation', {...body, attributeStoreId: newEditItem?.id, asistenteIaAtributos: useIa})
        iaResponse = response.data.iaResponse
        setDataResponse('Creado con éxito')
        setErrorResponse(null)
      }
      if (iaResponse !== undefined && typeof iaResponse === 'string') {
        toast.error(iaResponse);
      }
      formatForm()
      setShowForm(false)
    } catch (error) {
      if (axios.isAxiosError(error)) {
        setErrorResponse(error.response?.data.message);
      } else if (error instanceof Error) {
        setErrorResponse([error.message]);
      } else {
        setErrorResponse(['Hubo un error en la solicitud']);
      }
    } finally {
      reloadTable()
      setLoadingResponse(false);
      setOpenIaModal(false)
    } 
  }
  
  const fetchAddAttributes = async (attributesToAdd: AttributeNewsan[]) => {
    try{
      onCloseAddAttrModal()
      setLoadingResponse(true)
      await client.post(`/categories/${dataGrid?.categoryData.id}/addAttributes`, {attributesIdsToAdd: attributesToAdd.map((attr) => attr.id)})
    } catch (error) {
      if (axios.isAxiosError(error)) {
        console.error(error.response?.data.message);
      } else if (error instanceof Error) {
        console.error([error.message]);
      } else {
        console.error(['Hubo un error en la solicitud']);
      }
    } finally {
      reloadTable()
      setLoadingResponse(false);
    } 
  }

  const deleteSuggestedAttribute = async ( body?: {relationAttributeId: number}) => {
    try{
      setLoadingResponse(true)
      await client.post('/attributes/removeSuggested', body)
      setDataResponse('Recomendación eliminada con éxito')
      setErrorResponse(null)
      formatForm()
      setShowForm(false)
    } catch (error) {
      if (axios.isAxiosError(error)) {
        setErrorResponse(error.response?.data.message);
      } else if (error instanceof Error) {
        setErrorResponse([error.message]);
      } else {
        setErrorResponse(['Hubo un error en la solicitud']);
      }
    } finally {
      reloadTable()
      setLoadingResponse(false);
    } 
  }

  const handleDeleteClick = (relationId: number) => {
    setSelectedRelationId(relationId);
    setOpenConfirmDialog(true);
  };

  const confirmDelete = async () => {
    if (selectedRelationId !== null) {
      setShowPopup(true);
      await deleteRelation(selectedRelationId);
      setOpenConfirmDialog(false);
      setSelectedRelationId(null);
    }
  };

  const deleteRelation = async (relationId: number) => {
      try {
        setLoadingResponse(true);
        await client.delete(`/attributes/${relationId}`);
        setDataResponse('Eliminado con éxito!');
        setErrorResponse(null);
      } catch (error) {
        if (axios.isAxiosError(error)) {
          setErrorResponse(error.response?.data.message);
        } else if (error instanceof Error) {
          setErrorResponse([error.message]);
        } else {
          setErrorResponse(['Hubo un error en la solicitud']);
        }
      } finally {
        reloadTable()
        setLoadingResponse(false);
      }
    }

  const saveFormInfo = () => {
    if (!selectedAttributeGEND){
      alert('Se deben completar todos los campos')
    } else {
      const temporalObject: {attributeNewsanId: number} = {
        attributeNewsanId: selectedAttributeGEND.id
      }
      setShowPopup(true);
      fetchData(temporalObject)
    }
  }

  useEffect(()=>{
    if(!loadingStore && !loading && dataGrid) {
      setCountItems(dataGrid.count)
      let iaAssistance : number[] = [];
      setDataShow(dataGrid.results.map((r) => {
        // const isDisabled =  r.dataType === null || r.dataType?.toUpperCase() === "TEXTO" || r.dataType?.toUpperCase() === "NUMERO";
        if (r.relationAttributes[0]?.suggestedAttributeNewsan?.id && !r.relationAttributes[0]?.attributeNewsan){
          iaAssistance.push(r.relationAttributes[0]?.id)
        }

        const actions: TableAction[] =  [
          new TableAction({label: 'Editar', action: () => {
            setNewEditItem(r)
            setShowForm(true)
          }, icon: <span className={classes.editIcon}><EditIcon></EditIcon></span>}),
        ]
        if (r.relationAttributes[0]?.attributeNewsan?.id){
          actions.push(
            new TableAction({label: 'Valores de Atributos', action: () => {
              navigate(`/atributos/${r.id}/${r.relationAttributes[0].id}/atributo-valores`)
            }, icon: <span className={classes.editIcon}>{NewsanIcons.SUMMARY}</span>,  /* enable: !isDisabled */ }),
            new TableAction({
              label: 'Eliminar',
              action: () => handleDeleteClick(r.relationAttributes[0].id),
              icon: NewsanIcons.DELETE,
              enable: r.relationAttributes.length > 0 
            }),
          )
        }

        return new TableDetailCell(
          {
            codeStore: `${r.code} - ${r.description}`,
            //TODO revisar si el color rojo es correcto...
            dataType: r.dataType,
            codeNewsan:
              r.relationAttributes.length > 0 && r.relationAttributes[0].attributeNewsan?.code && r.relationAttributes[0].attributeNewsan?.description
                ? `${r.relationAttributes[0].attributeNewsan?.code} - ${r.relationAttributes[0].attributeNewsan?.description}`
                : r.relationAttributes?.[0]?.suggestedAttributeNewsan?.code &&  r.relationAttributes?.[0]?.suggestedAttributeNewsan?.description && r.relationAttributes?.[0]?.suggestedAttributeNewsan?.id ? 
                <div className={classes['iaContent']}>
                  <span>{r.relationAttributes?.[0]?.suggestedAttributeNewsan?.code} - {r.relationAttributes?.[0]?.suggestedAttributeNewsan?.description}</span>
                  <span className={classes['iaText']}>Recomendacion IA</span>
                  <div className={classes['iaButtonContent']}>
                    <Button className={classes['iaButton']} onClick={async () => {
                      if (r.relationAttributes?.[0]?.suggestedAttributeNewsan?.id){
                        setShowPopup(true);
                        await fetchData({attributeNewsanId: r.relationAttributes?.[0]?.suggestedAttributeNewsan?.id}, r.relationAttributes[0].id)
                      }
                    }}>Si</Button>
                    <Button className={classes['iaButton']} onClick={async () => {
                      if (r.relationAttributes?.[0]?.suggestedAttributeNewsan?.id){
                        setShowPopup(true);
                        await deleteSuggestedAttribute({relationAttributeId: r.relationAttributes[0].id})
                      }
                    }}>No</Button>
                  </div>
                </div>
                : <span className={classes.error}>Sin configurar</span>,
          }
          , actions,
        undefined, 
        classes['storesDataTable'])
      }))
      setIdsSuggesteds(iaAssistance);
    }
  }, [setDataShow, dataGrid, loading, loadingStore]);

  const handleMassiveSuggestions = async (isAccepted: boolean) => {
        try{
          setLoadingResponse(true)
          setOpenIaModal(true)
          await client.post(`/attributes/${isAccepted ? 'massive-accept-suggested' : 'massive-remove-suggested'}`, {relationAttributeIds: idsSuggested})
          setDataResponse(`Recomendaciónes ${isAccepted ? 'aceptadas' : 'rechazadas'} con éxito`)
          setErrorResponse(null)
          formatForm()
          setShowForm(false)
        } catch (error) {
          if (axios.isAxiosError(error)) {
            setErrorResponse(error.response?.data.message);
          } else if (error instanceof Error) {
            setErrorResponse([error.message]);
          } else {
            setErrorResponse(['Hubo un error en la solicitud']);
          }
        } finally {
          reloadTable();
          setLoadingResponse(false);
          setOpenIaModal(false)
        } 
      }

    const suggestAttributesValues = async () => {
          try{
            setOpenIaModal(true)
            setLoadingResponse(true)
            await client.post(`/attributes/suggest-attributes/${idRelationsCategory}`)
            setDataResponse(`Se ha realizado la sugerencia correctamente`)
            setErrorResponse(null)
            formatForm()
            setShowForm(false)
          } catch (error) {
            if (axios.isAxiosError(error)) {
              toast.error(error.response?.data.message);
            } else if (error instanceof Error) {
              toast.error(error.message);
            } else {
              toast.error('Hubo un error en la solicitud');
            }
          } finally {
            reloadTable();
            setLoadingResponse(false);
            setOpenIaModal(false)
          } 
        }

  useEffect(()=>{
      if(newEditItem){
        setSelectedAttributeGEND(dataOptionsGend?.find(gendOption => gendOption.code.toString() == newEditItem.relationAttributes[0]?.attributeNewsan?.code.toString()) || undefined);
      }
    }, [newEditItem]);

  function formatForm(){
    setSelectedAttributeGEND(undefined)
  }

  function reloadTable() {
    setBaseEndpoint('')
    setEndPoint('')
    setEndpointAttributes('')
    setIdsSuggesteds([])
  }

  return (
    <div className={classes.errorTransactionPage}>
      {
        loading || loadingStore || loadingResponse || loadingOptionsGend ?
        <div className='loadingPage'>
          <CircularProgress className='circleProgress'/>
        </div>
        : null
      }
      <div className={classes.storesPage}>
      <Topbar title={`Atributos - Categoria ${dataGrid?.categoryData?.code}-${dataGrid?.categoryData?.description} - Tienda ${dataStore?.description}`} backButton hasReloadIcon reloadPage={reloadTable} >
        {idsSuggested.length > 0 ? <div className={classes['iaContent']} style={{
          justifyContent: 'flex-end'
        }}>
            <span className={classes['iaText']}>Recomendaciones IA</span>
            <div className={classes['iaButtonContent']}>
              <Button className={classes['iaButton']} onClick={async () => {
                setShowPopup(true);
                await handleMassiveSuggestions(true)
              }}>Si</Button>
              <Button className={classes['iaButton']} onClick={async () => {
                setShowPopup(true);
                await handleMassiveSuggestions(false)
              }}>No</Button>
            </div>
          </div>:
          <div className={classes['iaContent']} style={{
            justifyContent: 'flex-end'
          }}>
            <div className={classes['iaButtonContent']}>
              <Button className={classes['iaButton']} onClick={async () => {
                setShowPopup(true);
                await suggestAttributesValues()
              }}>Sugerir Sinonimia</Button>
            </div>
          </div>
          }
      </Topbar>
      <div className={
          showForm ? classes['table-templates-container-form-visible'] : classes['table-templates-container']
        }>
          <DataTable
            headers={dataHeader}
            headerActions={headerActions}
            rows={dataShow}
            countItems={countItems}
            rowsPerPage={dataTo}
            hasActions={true}
            groupActions={false}
            appendOnScrollToBottom={false}
            onPageSizeChange={(size) => {setDataTo(size); setDataOffset(0); }}
            onPageChange={(page: number)=>{ setDataOffset(page-1) }}
            pageSelected={dataOffset+1}
            pageable={true}
            selectable={false}
            className={classes.storesDataTable}
          ></DataTable>
        </div>
      {showForm && newEditItem ? (
        <div className={classes['abm-container']}>
          <div className={classes['edit-form-container']}>
            <span className={classes['title-form']}>
              {NewsanIcons.ADD_OUTLINED}{' '}
              <span className={classes['title-form-text']}>Editar</span></span>
            <CloseIcon
              className={classes['form-close-button']}
              onClick={() => {
                formatForm()
                setShowForm(false)
                setNewEditItem(undefined)
              }}
            ></CloseIcon>
            <span className={classes['setting-attr-title']}>Atributo tienda</span>
            <input
              type='text'
              className={classes['setting-attr-input']}
              placeholder='Nombre de la tienda'
              value={`${newEditItem?.code} - ${newEditItem?.description}`}
              disabled
            />
            <CustomAutocomplete
              label="Atributo GenD*"
              value={
                selectedAttributeGEND
                  ? { id: selectedAttributeGEND.id, description: selectedAttributeGEND.description }
                  : newEditItem?.relationAttributes[0]?.attributeNewsan
                    ? {
                        id: newEditItem.relationAttributes[0].attributeNewsan.id,
                        description: newEditItem.relationAttributes[0].attributeNewsan.description
                      }
                    : undefined
              }
              options={
                (dataOptionsGend || []).map(attr => ({
                  id: attr.id,
                  description: attr.description
                }))
              }
              onChange={(option) =>
                setSelectedAttributeGEND(
                  dataOptionsGend?.find(attr => attr.id === option?.id)
                )
              }
            />
            <div className={classes['buttons-container']}>
              <Button
                variant='contained'
                className={classes['btn-newsan-cancel']}
                onClick={() => {
                  setShowForm(false)
                  setNewEditItem(undefined)
                  setDataResponse(null)
                  setErrorResponse(null)
                  formatForm()
                }}
              >
                Cancelar
              </Button>
              <Button
                variant='contained'
                onClick={async() => {await saveFormInfo();}}
                className={ classes['button-newsan-red']}
              >Guardar
              </Button>
            </div>
          </div>
        </div>
      ) : null}
      </div>

      <ConfirmDialog
        open={openConfirmDialog}
        onClose={() => setOpenConfirmDialog(false)}
        onConfirm={confirmDelete}
        title="Confirmar eliminación"
        message="¿Está seguro de que desea eliminar esta configuración?"
      />

      <Modal
        open={openIaModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        onClose={(event, reason) => {
          if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
            handleCloseIaModal();
          }
        }}
      >
        <Box sx={{position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
          borderRadius: 4,
          boxShadow: 24,
          border: '2px solid var(--primary-color)',
          p: 3,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '2vw'
        }}>
          <Typography>Se está ejecutando el asistente de sinonimia, este proceso puede demorar varios segundos. Gracias por la espera.</Typography>
            <CircularProgress />
        </Box>
      </Modal>

      {showAddAttributes && dataGrid && !loadingAttributesToAdd ? (
        <Dialog open={showAddAttributes} onClose={() => onCloseAddAttrModal()} maxWidth="md" fullWidth>
          <DialogTitle>
            Replicar sinonimia para atributos y valores de atributos
          </DialogTitle>
          <DialogContent dividers>
          <Autocomplete
            multiple
            options={dataAttributesToAdd ?? []}
            getOptionLabel={(option) => `${option?.code} - ${option?.description}` }
            value={selectedAttributes}
            onChange={(event, newValue) => {
              if (newValue.length <= 8) {
                console.log(newValue)
                setSelectedAttributes(newValue);
              }
            }}
            filterSelectedOptions
            getOptionDisabled={(option) =>
              Boolean(selectedAttributes && selectedAttributes.length >= 8 && selectedAttributes.includes(option))
            }
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder={'Ingrese una categoria'}
                label={''}
                size="small"
                sx={{
                  fontFamily: 'Gilroy-Medium',
                  fontSize: '14px',
                  '& .MuiInputBase-input::placeholder': {
                    color: 'rgba(0, 0, 0, 1)',
                    fontFamily: 'Gilroy-Medium',
                    fontSize: '14px',
                  },
                }}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {loading ? <CircularProgress color='inherit' size={20} /> : null}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                }}
              />
            )}
          />
          </DialogContent>
          <DialogActions>
            <Box>
              <Button onClick={() => onCloseAddAttrModal()} variant="contained" className={classes['button-newsan-grey']}>
                Cancelar
              </Button>
              <Button onClick={async () => {await fetchAddAttributes(selectedAttributes);}} variant="contained" color="primary" className={classes['button-newsan-red']}>
                Guardar
              </Button>
            </Box>
          </DialogActions>
        </Dialog>
      ) : <></>}
    </div>
  )
}

export default Attributes;
